import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';


export default function HeaderToolbar() {
    const [open, setOpen] = React.useState(false);
    
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };
    const DrawerList = (

            <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
                <List>
                    {['Profile', 'Settings'].map((text, index) => (
                        <ListItem key={text} disablePadding>
                            <ListItemButton>
                                <ListItemText primary={text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                <Divider />
                <List>
                    {['Contact us', 'About'].map((text, index) => (
                        <ListItem key={text} disablePadding>
                            <ListItemButton>
    
                                <ListItemText primary={text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>

    
    );

    return (
        <div>
        <Drawer open={open} anchor={'right'} onClose={toggleDrawer(false)}>
          {DrawerList}

        </Drawer>
        
        <Box sx={{ flexGrow: 1 }}>
            <img className="logo" src='/app/logo-dark.png' height='60px' /*onClick={toggleDrawer(true)} *//>
            <AppBar position="fixed" color='primary' enableColorOnDark >

                <Toolbar >
                    <Typography   sx={{ flexGrow: 1 }}></Typography >
                    <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2, zIndex: 999 }}
                    onClick={toggleDrawer(true)}
                    >
                        <AccountCircle />
                    </IconButton>
                </Toolbar>
            </AppBar>
        </Box>
        </div>

    )
}

